module.exports = __webpack_public_path__ + "static/1-a5a65dd6cd4f36efbcec2dd36090a856.jpg";